export default __webpack_public_path__ + "static/media/coloured-card-with-btn.da577827.jpg";